import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from './CTAButton';
const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 40
  },
  whileInView: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: 'easeOut'
    }
  },
  viewport: {
    once: true,
    margin: '-100px'
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  whileInView: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  },
  viewport: {
    once: true,
    margin: '-50px'
  }
};
export function SolutionSection() {
  const deliverables = [{
    title: 'El Manual Digital Completo',
    desc: 'Estrategias paso a paso para dominar tu temperatura.'
  }, {
    title: 'La Técnica 4-4-8',
    desc: 'El método exacto para bajar las pulsaciones y enfriar la sangre en segundos.'
  }, {
    title: 'Guía de Invisibilidad Social',
    desc: 'Cómo ganar tiempo y disimular el rubor sin que nadie sospeche.'
  }, {
    title: 'El Kit de Emergencia del Bolso',
    desc: 'Los 3 elementos económicos que te rescatarán en cualquier reunión.'
  }, {
    title: 'Mapa de Gatillos Alimenticios',
    desc: 'Qué comer (y qué evitar) para que tu almuerzo no se convierta en una sauna.'
  }];
  return <>
      {/* The Unique Mechanism */}
      <section className="bg-brand-teal text-brand-cream py-24 px-6 relative overflow-hidden" data-id="element-133">
        {/* Subtle background pattern/glow */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-134"></div>

        <motion.div initial="hidden" whileInView="whileInView" viewport={{
        once: true
      }} variants={fadeInUp} className="max-w-4xl mx-auto relative z-10" data-id="element-135">
          <h2 className="font-serif text-3xl md:text-5xl font-bold mb-8 text-center" data-id="element-136">
            El extintor de incendios invisible
          </h2>
          <div className="font-sans text-lg md:text-xl text-brand-cream/90 leading-relaxed space-y-6" data-id="element-137">
            <p data-id="element-138">
              Presentamos el{' '}
              <strong className="text-white font-semibold" data-id="element-139">
                Interruptor Térmico Somático
              </strong>
              . A diferencia de los métodos tradicionales, este protocolo no
              espera a que el sofoco pase.
            </p>
            <p data-id="element-140">
              Utiliza técnicas de respiración de CO2 y puntos de presión
              específicos en la base del cráneo para enviarle una señal de
              "falsa calma" a tu hipotálamo. Al engañar a tu sistema nervioso,
              obligas a tu cuerpo a apagar la respuesta de calor antes de que el
              sudor sea visible.
            </p>
            <p className="text-center font-serif italic text-2xl pt-4 text-brand-coral" data-id="element-141">
              Es como tener un extintor de incendios invisible en tu bolsillo.
            </p>
          </div>
        </motion.div>
      </section>

      {/* What You Get */}
      <section className="bg-brand-cream py-24 px-6" data-id="element-142">
        <div className="max-w-5xl mx-auto" data-id="element-143">
          <motion.h2 initial="hidden" whileInView="whileInView" viewport={{
          once: true
        }} variants={fadeInUp} className="font-serif text-3xl md:text-4xl font-bold text-brand-charcoal mb-16 text-center" data-id="element-144">
            Lo que obtienes hoy
          </motion.h2>

          <motion.div variants={staggerContainer} initial="hidden" whileInView="whileInView" className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-145">
            {deliverables.map((item, index) => <motion.div key={index} variants={fadeInUp} className={`bg-white p-8 rounded-2xl shadow-sm border border-brand-sage/50 flex items-start gap-5 ${index === deliverables.length - 1 ? 'md:col-span-2 md:max-w-2xl md:mx-auto' : ''}`} data-id="element-146">
                <div className="bg-brand-sage p-2 rounded-full shrink-0" data-id="element-147">
                  <CheckCircle2 className="w-6 h-6 text-brand-teal" data-id="element-148" />
                </div>
                <div data-id="element-149">
                  <h3 className="font-serif font-bold text-xl text-brand-charcoal mb-2" data-id="element-150">
                    {item.title}
                  </h3>
                  <p className="font-sans text-brand-charcoal/80 leading-relaxed" data-id="element-151">
                    {item.desc}
                  </p>
                </div>
              </motion.div>)}
          </motion.div>
        </div>
      </section>
    </>;
}